import * as ng from 'angular';

import './img-upload-modal.controller';

const imgUploadModal = require('./img-upload-modal.html');

export class ImgUploadController implements ng.IController {
   static $inject:string[] = ['$uibModal'];

   constructor(private $uibModal) { }

   $onInit() {
      if (this.scale) {
         this.sizeStyle = {
            width: `${this.width * this.scale}px`,
            height: `${this.height * this.scale}px`
         };
      }
   }

   ngModelCtrl: ng.INgModelController;

   // optional default image
   default?: string;

   // height of the final cropped image
   height: number;
   // width of the final cropped image
   width: number;

   // set scale to use fixed display width/height for the interface
   scale?: number;

   // when scale is set this is element style map
   sizeStyle:any = { };

   get image(): string {
      return this.ngModelCtrl.$modelValue;
   }

   set image(val: string) {
      this.ngModelCtrl.$setViewValue(val);
   }

   onShowModal() {
      const promise = this.$uibModal.open({
         size: 'lg',
         backdrop: 'static',
         resolve: {
            settings: () => {
               return {
                  height: this.height,
                  width: this.width,
               }
            }
         },
         templateUrl: imgUploadModal,
         controller: 'ImgUploadModalController as ctrl'
      }).result;

      promise.then(data => this.image = data);
   }

   onRemove() {
      this.image = null;
   }

   onDefault() {
      if (this.default) {
         this.image = this.default;
      }
   }
}

ng.module('e360')
   .controller('ImgUploadController', ImgUploadController);
